import { Component, OnDestroy } from '@angular/core';
import { BaseComponent } from 'src/app/components/base.component';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';
import { catchError, combineLatest, distinctUntilChanged, map, Observable, of, startWith, switchMap, takeUntil, tap } from 'rxjs';
import { FileSdk } from "@sdks/file.sdk";
import { Store } from "@ngrx/store";
import { DocViewerActions } from "@store/doc-viewer/doc-viewer.actions";
import { pdfPage } from "@store/doc-viewer/doc-viewer.selectors";
import { UserConfigsService } from '@services/user-configs.service';

@Component({
    selector: 'lex-doc-viewer-pdf-content',
    templateUrl: './doc-viewer-pdf-content.component.html',
    styleUrls: ['./doc-viewer-pdf-content.component.scss'],
    standalone: false
})
export class DocViewerPdfContentComponent extends BaseComponent implements OnDestroy {

	public isContextPanelResizing: boolean;
	public pageNumber$ = this.store.select(pdfPage());
	public currentPage: number = 1;
	public useDefaultViewer: boolean = true;

	public url$: Observable<string> = combineLatest([this.docViewerStore.currentDocument$, this.pageNumber$]).pipe(
		distinctUntilChanged(([prevDocument, prevPage], [currentDocument, currentPage]) =>
			prevDocument.docId === currentDocument.docId &&
			prevPage === currentPage
		),
		tap(([, pageNumber]) => {
			this.currentPage = pageNumber;
		}),
		switchMap(([currentDocument,]) => {
			return this.fileSdk.getFileDownloadUrl({
				docId: currentDocument.docId,
				fileType: 6
			}).pipe(
				map((response) => {
					return response.url + `#page=${this.currentPage}`;
				}),
				catchError(() => of(null)),
				startWith(null)
			);
		}),
		takeUntil(this.destroy$)
	);

	constructor(
		private docViewerStore: DocViewerStore,
		private userConfigsService: UserConfigsService,
		private fileSdk: FileSdk,
		private store: Store
	) {
		super();

		this.docViewerStore.simpleState$.pipe(
			takeUntil(this.destroy$)
		).subscribe((currentState) => {
			this.isContextPanelResizing = currentState.isContextPanelResizing;
		});

		if (this.userConfigsService.inRoles(this.roles.Developer)) {
			const viewer = localStorage.getItem("pdf-viewer-version");
			if (viewer && viewer === 'integrated')
				this.useDefaultViewer = false;
		} else {
			this.useDefaultViewer = true;
		}
	}

	public ngOnDestroy(): void {
		this.store.dispatch(DocViewerActions.pdfPageUpdate({ selectedPage: 1 }));
	}
}
